import axios from "axios";

export async function getAllOpeningHoursConstantAction() {
  const token =
    sessionStorage.getItem("token") ?? localStorage.getItem("token");

  return await axios
    .get(
      `${process.env.REACT_APP_API_ORIGIN}/1.0.0/cms/opening-hours-constant`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    )
    .then((res) => res.data);
}
